import { render } from "./ClearAllFilters.vue?vue&type=template&id=4c5cab5f"
import script from "./ClearAllFilters.vue?vue&type=script&lang=js"
export * from "./ClearAllFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__